import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy `/report/:shareToken` route — RETIRED.
 *
 * The client-facing report is now the single branded React page at
 * `/r/:shareToken` (the SAME page the PDF and the emailed link use).
 * This component now just redirects there so any old `/report/...` link
 * keeps working; it no longer renders its own standalone page.
 */
export default function PublicReportPage() {
  const { shareToken } = useParams();
  return <Navigate to={`/r/${shareToken}`} replace />;
}
